import config from "react-global-configuration"

// // to use hostname base url start with : 'set HTTPS=true&&set HOST=local.www.cph.dk&& yarn start'
// const PARKING_BASE_URL = config.hosts.PARKING_BASE_URL '//parking-ms-local.cph.dk'
// const IDP_BASE_URL = '//uatidp.cph.dk'
// const LOGIN_BASE_URL = '//uat.cph.dk'
// // const PARKING_BASE_URL = 'http://localhost:55823'

export const hosts = (c) => {
  if (c) {
    return c
  }
  let h = config.get("hosts")
  if (h) return h
  return {
    PARKING_BASE_URL: "//parking-ms-local.cph.dk",
    IDP_BASE_URL: "//uatidp.cph.dk",
    LOGIN_BASE_URL: "//uat.cph.dk",
    FLIGHT_BASE_URL: "//cph-flightinfo-uat.azurewebsites.net",
    COMMERCE_BASE_URL: "//cph-core-products-uat.azurewebsites.net",
    WAITING_TIME_BASE_URL: "//cphwaitingtime.z6.web.core.windows.net",
    PUBLISHED_FLIGHT_BASE_URL: "//cphflightuat.z6.web.core.windows.net",
  }
}

export const locale = (l) => {
  if (l) {
    return l
  }
  return config.get("locale") || "da"
}

//parking content
export const PARKING_CONTENT = (data, c) => `${hosts(c).PUBLISHED_FLIGHT_BASE_URL}/api/parking/parkingcontent/${data.language}.json`
export const PARKING_CONFIG = (data, c) => `${hosts(c).PUBLISHED_FLIGHT_BASE_URL}/api/parking/parkingconfiguration/${data.language}.json`

// parking booking
export const FIND_PARKING = (c, l) => `${hosts(c).PARKING_BASE_URL}/api/v1/${locale(l)}/booking/search`
export const FIND_PARKING_CHANGE = (guid) => `${hosts().PARKING_BASE_URL}/api/v1/${locale()}/booking/${guid}/search`
export const FIND_PARKING_CHANGE_TIMEONLY = (guid) => `${hosts().PARKING_BASE_URL}/api/v1/${locale()}/booking/${guid}/changetime`
export const FIND_BOOKING = () => `${hosts().PARKING_BASE_URL}/api/v1/${locale()}/booking`
export const FIND_BOOKING_BY_GUID = (guid) => `${hosts().PARKING_BASE_URL}/api/v1/${locale()}/booking/${guid}`
export const FIND_BOOKING_UPSALE_BY_GUID = (guid) => `${hosts().PARKING_BASE_URL}/api/v1/${locale()}/booking/${guid}/searchupsale`
export const EXECUTE_BOOKING_UPSALE_BY_GUID = (guid) => `${hosts().PARKING_BASE_URL}/api/v1/${locale()}/booking/${guid}/executeupsale`
export const FIND_BOOKING_EXTENSION_BY_GUID = (guid) => `${hosts().PARKING_BASE_URL}/api/v1/${locale()}/booking/${guid}/searchextension`
export const EXECUTE_BOOKING_EXTENSION_BY_GUID = (guid) => `${hosts().PARKING_BASE_URL}/api/v1/${locale()}/booking/${guid}/executeextension`
export const RESEND_BOOKING_RECEIPT = (guid) => `${hosts().PARKING_BASE_URL}/api/v1/${locale()}/booking/${guid}/resendreceiptfromcrm`
export const RESEND_ALL_MAILS = () => `${hosts().PARKING_BASE_URL}/api/v1/${locale()}/booking/sendEmailReminders`
export const ADD_RESERVATION = () => `${hosts().PARKING_BASE_URL}/api/v1/${locale()}/booking/reserve`
export const CHANGE_PARKING_INFORMATION = (guid) => `${hosts().PARKING_BASE_URL}/api/v1/${locale()}/booking/${guid}/change`
export const FIND_EXTRAS = (guid) => `${hosts().PARKING_BASE_URL}/api/v1/${locale()}/booking/${guid}/extras/find`
export const FIND_EXTRAS_WITH_CONFIG = (guid) => `${hosts().PARKING_BASE_URL}/api/v1/${locale()}/booking/${guid}/extras/findwithconfig`
export const ADD_EXTRAS = (guid) => `${hosts().PARKING_BASE_URL}/api/v1/${locale()}/booking/${guid}/extras`
export const REMOVE_EXTRAS = (guid) => `${hosts().PARKING_BASE_URL}/api/v1/${locale()}/booking/${guid}/extras`
export const REMOVE_EXTRAS_OFFERLINE = (guid) => `${hosts().PARKING_BASE_URL}/api/v1/${locale()}/booking/${guid}/extras/offerline`
export const MODIFY_BOOKING_INFORMATION = (guid) => `${hosts().PARKING_BASE_URL}/api/v1/${locale()}/booking/${guid}/modify`
export const CHANGE_UPGRADE_BOOKING = (guid) => `${hosts().PARKING_BASE_URL}/api/v1/${locale()}/booking/${guid}/changeupgrade`
export const EMAIL_UPGRADE_BOOKING = (guid) => `${hosts().PARKING_BASE_URL}/api/v1/${locale()}/booking/${guid}/emailupgrade`
export const GENERATE_PDF_RECEIPT = (guid) => `${hosts().PARKING_BASE_URL}/api/v1/${locale()}/booking/${guid}/pdf-receipt`
export const CANCELLATION = (guid) => `${hosts().PARKING_BASE_URL}/api/v1/${locale()}/booking/${guid}/cancellation`
export const BOOKING_LIST = (c, l) => `${hosts(c).PARKING_BASE_URL}/api/v1/${locale(l)}/booking/listByFlightDate`
export const MOST_BOOKED_STRUCTURE_ALTITUDE = (c, l) =>
  `${hosts(c).PARKING_BASE_URL}/api/v1/${locale(l)}/booking/structureBookingFrequencyFromAltitude`
export const MOST_BOOKED_STRUCTURE_CRM = (c, l) => `${hosts(c).PARKING_BASE_URL}/api/v1/${locale(l)}/booking/structureBookingFrequencyFromCrm`
export const VERIFY_LICENSE_PLATE = (licenseplate) => `${hosts().PARKING_BASE_URL}/api/v1/licenseplate/${licenseplate}`
export const BOOKING_BY_USER_LIST = (c) => `${hosts(c).PARKING_BASE_URL}/api/v1/da/booking/list`
export const RESEND_NEXT_AVAILABLE_BOOKING_CONFIRMATION = (c) =>
  `${hosts(c).PARKING_BASE_URL}/api/v1/${locale()}/booking/resendNextAvailableBookingConfirmation`

// IDP
export const HAS_SESSION = (c) => `${hosts(c).IDP_BASE_URL}/api/accountinfo/hassession`
export const ACCOUNT_DETAILS = (c) => `${hosts(c).IDP_BASE_URL}/api/contactdetails`
export const ACCOUNT_LOGIN = (c, l) => `${hosts(c).LOGIN_BASE_URL}/idpimplicitflow/login?language=${locale(l)}`
export const GET_TRAVEL_INFORMATION = (c) => `${hosts(c).IDP_BASE_URL}/api/travelinformation/gettravelinformation`
export const GET_TRAVEL_INFORMATION_BY_ID = (c, id) => `${hosts(c).IDP_BASE_URL}/api/travelinformation/gettravelinformation/${id}`
export const MOST_BOOKED_STRUCTURE_CRM_IDP = (c) => `${hosts(c).IDP_BASE_URL}/api/parking/getParkingStructureBookingFrequency`
export const MOST_BOOKED_STRUCTURE_CRM_IDP_BY_ID = (c, id) => `${hosts(c).IDP_BASE_URL}/api/parking/getParkingStructureBookingFrequency/${id}`
export const VERIFY_PHONE = (c, code) => `${hosts(c).LOGIN_BASE_URL}/idpimplicitflow/VerifyPhoneNumber?activationCode=${code}`
export const VERIFY_PHONE_2 = (c, code, email) => `${hosts(c).LOGIN_BASE_URL}/idpimplicitflow/VerifyPhoneNumber?activationCode=${code}&email=${email}`
export const VERIFY_PHONE_3 = (c) => `${hosts(c).LOGIN_BASE_URL}/idpimplicitflow/VerifyPhoneNumberPost`
export const UPDATE_PHONE = (c, phone) => `${hosts(c).LOGIN_BASE_URL}/idpimplicitflow/UpdatePhoneNumber?phone=${phone}`

// payments
export const PREPARE_PAYMENT = (guid, extensionId) =>
  `${hosts().PARKING_BASE_URL}/api/v1/da/booking/${guid}/prepareForPayment${!extensionId ? "" : "?extensionId=" + extensionId}`
export const INITIATE_PAYMENT_V2 = () => `${hosts().PARKING_BASE_URL}/api/v1/payment/Initiate-v2`
export const INITIATE_PAYMENT_MP = () => `${hosts().PARKING_BASE_URL}/api/v1/payment/initiate-mp`
export const PAYMENT_STATUS = (guid, extensionId) =>
  `${hosts().PARKING_BASE_URL}/api/v1/payment/PollPaymentStatus?bookingGuid=${guid}${!extensionId ? "" : "&extensionId=" + extensionId}`

// flights
export const WAITING_TIME_SECURITY = (c) => `${hosts(c).WAITING_TIME_BASE_URL}/waitingtime.json`
export const WAITING_TIME_PASSPORT = (c, type) => `${hosts(c).WAITING_TIME_BASE_URL}/${type}.json`
// export const WAITING_TIME = (c, type) => `${hosts(c).FLIGHT_BASE_URL}/api/v1/waiting/get?type=${type}`
export const FLIGHT_INFO = (c, flightId) => `${hosts(c).FLIGHT_BASE_URL}/api/v1/flight/${flightId}`
export const FLIGHT_INFO_SOLR = (c, language, flightId) =>
  `${hosts(c).LOGIN_BASE_URL}/api/FlightInformation/GetFlightInfo?flightId=${flightId}&language=${language}`

//orders
export const TAXFREE_ORDERS = (c, email) => `${hosts(c).COMMERCE_BASE_URL}/api/v1/Orders/user/${email}`
